import { showErrorNotification, showSuccessNotification } from '../../global/notifications';

let _$section = null;
let _isFinalSection = null;
let _id = null;

export default function (id, section) {
    _id = id;
    _$section = $(section);
    _isFinalSection = _$section.attr('id') === 'distribution-final-bonus-plan';

    attachPercentEvents();
    setAdjustFunction();
    calculatePercentTotal();

    /*Bonus Plan management events*/
    attachAddBonusPlanEvent();
    attachDeleteButtonEvent();
    attachSharePlanPercentEvent();
}
/*General*/
const setSection = (ele) => {
    _$section = $(ele).parents('#distribution-base-bonus-plan, #distribution-final-bonus-plan');
    _isFinalSection = _$section.attr('id') === 'distribution-final-bonus-plan';
}

/*Percent Change Functions*/
const setAdjustFunction = () => {
    const k_inputs = _$section.find('input.js-percent.js-share-percent[data-role="numerictextbox"], input.js-percent.js-bonus-plan-share[data-role="numerictextbox"]');
    $.each(k_inputs, function (index, ele) {
        const k_input = $(ele).data('kendoNumericTextBox');
        if (k_input) overwriteAdjustFunction(k_input);
    })
}
const overwriteAdjustFunction = (k_numericTextBox) => {
    k_numericTextBox._originalAdjust = k_numericTextBox._originalAdjust || k_numericTextBox._adjust;
    k_numericTextBox._adjust = function () {
        // if(arguments[0] < this.min()){}
        if (arguments[0] > this.max()) {
            showErrorNotification(`Cannot exceed ${this.max()}. Total should not be more than 100`)
        }
        return k_numericTextBox._originalAdjust.apply(this, arguments);
    };
}
const calculatePercentTotal = () => {
    let $percentInputs = _$section.find('.js-share-percent');
    let percentTotal = 0;

    const $finalBonus = $('[name=FinalBonus]');
    const finalBonus = $finalBonus.val() || 0;
    const $payrollExpensePercent = $('.js-share-percent[data-role-id="-1"]');
    const payrollExpensePercent = $payrollExpensePercent.data('value') || 0;

    $.each($percentInputs, function (index, ele) {
        const $percentElement = $(ele);
        const roleId = Number($percentElement.data('role-id'));
        if (roleId > 0) {
            const percentValue = $percentElement.data('value');
            percentTotal += Number(percentValue || 0);

            const $totalValue = $percentElement.parents('[data-id]').find('.js-total-value');
            if ($totalValue.length) {
                const totalValue = (finalBonus * percentValue) / (1 + payrollExpensePercent);
                setElementValue($totalValue, totalValue, '{0:c2}');
            }
        }
    });

    let $percentTotal = _$section.find('.js-share-percent-total');

    let reserveAmount = updateReserve(percentTotal);
    $percentTotal.data('value', percentTotal + reserveAmount);
    $percentTotal.text(kendo.format('{0:p2}', (percentTotal || 0)));

    if (_isFinalSection) calculateTotalAmountPaid();
}

const updateReserve = (percentTotal) => {
    const $reservePercent = _$section.find('.js-share-percent[data-role-id="0"]');
    const reserveMin = _isFinalSection ? 0 : .25;
    let reservePercent = 1 - percentTotal;
    if (reservePercent < reserveMin) reservePercent = reserveMin;
    $reservePercent.data('value', reservePercent)
    $reservePercent.text(kendo.format('{0:p2}', (reservePercent || 0)));

    updateReserveAmount(reservePercent);
    updatePayrollExpenseAmount(reservePercent);

    return reservePercent;
}

const updateReserveAmount = (reservePercent) => {
    const $finalBonus = $('[name=FinalBonus]');
    const finalBonus = $finalBonus.val();
    const $payrollExpense = $('.js-share-percent[data-role-id="-1"]');
    const payrollExpense = $payrollExpense.data('value');

    const reserveAmount = (finalBonus * reservePercent) / (1 + payrollExpense);

    const $reserveAmount = _$section.find('.js-total-value[data-role-id="0"]');
    $reserveAmount.data('value', reserveAmount)
    $reserveAmount.text(kendo.format('{0:c2}', (reserveAmount || 0)));
}

const updatePayrollExpenseAmount = (reservePercent) => {
    const $finalBonus = $('[name=FinalBonus]');
    const finalBonus = $finalBonus.val();

    const $payrollExpensePercent = $('.js-share-percent[data-role-id="-1"]');
    const payrollExpensePercent = $payrollExpensePercent.data('value');

    const payrollExpenseAmount = ((finalBonus * (1 - reservePercent)) / (1 + payrollExpensePercent)) * payrollExpensePercent;

    const $payrollExpenseAmount = _$section.find('.js-total-value[data-role-id="-1"]');
    $payrollExpenseAmount.data('value', payrollExpenseAmount)
    $payrollExpenseAmount.text(kendo.format('{0:c2}', (payrollExpenseAmount || 0)));
}

const savePercentage = (data) => {
    return new Promise((resolve, reject) => {
        $.post('/Operations/ProfitShare/UpdateBonusPlan', {
            ProfitShareId: _id,
            Id: data.id,
            SharePercent: data.value,
            isFinal: _isFinalSection
        }, function (response) {
            if (response.success) resolve(response.message);
            else reject(response.message);
        })
    });
}
const attachPercentEvents = () => {
    const $percentInputs = _$section.find('input.js-share-percent');

    $.each($percentInputs, function (index, ele) {
        const k_input = $(ele).data('kendoNumericTextBox');

        if (k_input) {
            k_input.unbind('change');
            k_input.bind('change', function (e) {
                setSection(ele)
                //Set data value
                $(ele).data('value', e.sender._value / 100);
                //Recalculate Share Percent Total
                calculatePercentTotal();

                //Save Percent information
                savePercentage(k_input.element.data())
                    .then(msg => showSuccessNotification(msg))
                    .catch(error => showErrorNotification(error))
            })

            k_input.element.unbind('focus');
            k_input.element.bind('focus', function () {
                setSection(k_input.element);
                const $reserveAmount = _$section.find('.js-share-percent[data-role-id="0"]');
                const reserveAmount = $reserveAmount.data('value') * 100;
                const percentTotal = _$section.find('.js-share-percent-total').data('value') * 100;

                const manualAmount = percentTotal - reserveAmount
                k_input.max(cleanDecimals((ReserveMax() - manualAmount + k_input.value()), 2));
            })
        }
    })
}

const ReserveMax = () => {
    return _isFinalSection ? 100 : 75;
}

/*Add Bonus Plan*/
const attachAddBonusPlanEvent = () => {
    const $addButton = _$section.find('.js-add-bonus-plan');
    $addButton.unbind('click');
    $addButton.bind('click', function () {
        $(this).attr('disabled', true);
        setSection($(this));
        addBonusPlan()
            .then(msg => showSuccessNotification(msg))
            .then(_ => attachDeleteButtonEvent())
            .then(_ => attachPercentEvents())
            .then(_ => setAdjustFunction())
            .then(_ => calculatePercentTotal())
            .then(_ => resetAddBonusPlan())
            .catch(error => showErrorNotification(error))
            .finally(() => $(this).attr('disabled', false));
    });
}
const createNumericTextBox = () => {
    $('input.js-percent').not('.k-input').kendoNumericTextBox({
        format: '##,#.00 \\%',
        spinners: false
    });
}
const addBonusPlan = () => {
    return new Promise((resolve, reject) => {
        const empValue = _$section.find('input.js-bonus-plan-employee').data('kendoAutoComplete').value();
        const hyphenIndex = empValue.indexOf('-');
        const title = empValue.substring(empValue.indexOf('(') + 1, empValue.indexOf(')')).trim();
        let data = {
            ProfitShareId: _id,
            Title: title,
            EmpId: empValue.substring(0, hyphenIndex).trim(),
            SharePercent: _$section.find('input.js-bonus-plan-share.js-percent[data-role="numerictextbox"]').data('kendoNumericTextBox').value() / 100,
            isFinal: _isFinalSection
        };

        if (isNaN(data.EmpId) || data.EmpId <= 0) {
            reject("Please enter a valid employee from list");
            return;
        }

        /*Get Employee already entered*/
        const $dataEmpId = _$section.find(`[data-emp-number="${data.EmpId}"]`);

        /*Check if employee was already added to user list*/
        if ($dataEmpId.length > 0) {
            reject('Employee already added');
            return;
        }

        /*Attempt to save new bonus plan information*/
        $.post('/Operations/ProfitShare/AddBonusPlan', data, function (response) {
            if (typeof response === 'object') {
                if (response.success) resolve(response.message);
                else reject(response.message);
            } else {
                let reserve = _$section.find('.js-bonus-plan-list div[data-id]:last-child')
                $(response).insertBefore(reserve);
                createNumericTextBox($(response));
                resolve("Successfully Added Bonus Plan");
            }
        })
    })
}
const resetAddBonusPlan = () => {
    // _$section.find('select.js-bonus-plan-role').data('kendoDropDownList').value('');
    _$section.find('input.js-bonus-plan-employee').data('kendoAutoComplete').value("");
    _$section.find('input.js-bonus-plan-share.js-percent[data-role="numerictextbox"]').data('kendoNumericTextBox').value("");
};

/*Delete Bonus Plan*/
const attachDeleteButtonEvent = () => {
    const $deleteButtons = _$section.find('.js-delete-button');
    $deleteButtons.unbind('click');
    $deleteButtons.bind('click', function () {
        $(this).attr('disabled', true);
        setSection($(this));
        deleteBonusPlan(this)
            .then(msg => showSuccessNotification(msg))
            .then(_ => calculatePercentTotal())
            .catch(error => showErrorNotification(error))
            .finally(() => $(this).attr('disabled', false))
    });
}
const deleteBonusPlan = (ele) => {
    return new Promise((resolve, reject) => {
        const $parent = $(ele).parents('[data-id]');
        const bonusId = $parent.data('id');

        $.post('/Operations/ProfitShare/DeleteBonusPlan', {
            bonusPlanId: bonusId,
            isFinal: _isFinalSection
        }, function (response) {
            if (response.success) {
                $parent.remove();
                resolve("Successfully deleted role");
            } else {
                reject('Failed to delete role');
            }
        })
    });
}

const attachSharePlanPercentEvent = () => {
    const $shareEntry = _$section.find('input.js-bonus-plan-share[data-role="numerictextbox"]');
    const k_shareEntry = $shareEntry.data('kendoNumericTextBox');

    if (k_shareEntry) {
        k_shareEntry.element.unbind('focus');
        k_shareEntry.element.bind('focus', function () {
            setSection(this);
            const $reserveAmount = _$section.find('.js-share-percent[data-role-id="0"]');
            const reserveAmount = $reserveAmount.data('value') * 100;
            const percentTotal = _$section.find('.js-share-percent-total').data('value') * 100;
            const manualTotal = percentTotal - reserveAmount;

            if (_isFinalSection) {
                k_shareEntry.max(cleanDecimals(100 - manualTotal, 2))
            } else {
                k_shareEntry.max(cleanDecimals(75 - manualTotal, 2));
            }
        });
    }
}

const cleanDecimals = (value, decimals = 0) => {
    const factor = Math.pow(10, decimals);
    return Math.round((value * factor) / factor);
}

const calculateTotalAmountPaid = () => {
    const $values = _$section.find('.js-total-value').not('[data-role-id="0"]');
    let totalPaid = 0;

    $.each($values, function (index, ele) {
        totalPaid += Number($(ele).data('value') || 0);
    });

    const $shareTotal = _$section.find('.js-share-total');
    $shareTotal.data('value', totalPaid);
    $shareTotal.text(kendo.format('{0:c2}', (totalPaid || 0)));
}


const setElementValue = (element, value, format) => {
    const $element = $(element);
    $element.data('value', value)
    $element.text(kendo.format(format, (value || 0)));
}
